import React, { useState, useEffect } from 'react';
import { Popover } from '@nextiva/next-ui-components';
import { find } from 'lodash';

import { MultiSelectSearch } from 'components';

import { Add } from '../../Add';
import { actionTypes } from '../../../../UserDrawerContent/UserDrawerContext';

Popover.displayName = 'ForwardRef(Modal)';

export const AddTeam = ({
  dispatchUserDrawer,
  teams,
  assignedTeams,
  primaryTeam,
}) => {
  const [addTeamOpen, setAddTeamOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedTeams, setSelectedTeams] = useState([]);

  useEffect(() => {
    setSelectedTeams(assignedTeams.map((team) => team.id));
  }, [assignedTeams]);

  const toggleAddTeam = (event) => {
    setAddTeamOpen((e) => !e);
    setAnchorEl(event.currentTarget);
  };

  const displayTeams = teams
    .filter((team) => team.key !== primaryTeam)
    .map((team) => {
      return {
        id: team.key,
        text: team.label,
      };
    });

  const handleNewTeamClick = (id) => {
    const teamToAdd = find(teams, { key: id });

    const newTeamsList = [...assignedTeams, teamToAdd.value];

    dispatchUserDrawer({
      type: actionTypes.SET_ASSIGNED_TEAMS,
      assignedTeams: newTeamsList,
    });
  };

  const handleSelectedTeamClick = (id) => {
    const newTeamsList = assignedTeams.filter((team) => team.id !== id);

    dispatchUserDrawer({
      type: actionTypes.SET_ASSIGNED_TEAMS,
      assignedTeams: newTeamsList,
    });
  };

  const handleAddTeamClick = (id) => {
    if (selectedTeams.includes(id)) {
      handleSelectedTeamClick(id);
    } else {
      handleNewTeamClick(id);
    }
  };

  return (
    <>
      <button
        type="button"
        className="m-user-edit-drawer-section__add"
        onClick={toggleAddTeam}
        data-testid="PlatformAdminUI-AddTeam-Button"
      >
        <Add text="team" />
      </button>
      <Popover
        open={addTeamOpen}
        anchorEl={anchorEl}
        onClose={toggleAddTeam}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MultiSelectSearch
          title="Add Teams"
          placeholder="Search Teams"
          options={displayTeams}
          selectedItems={selectedTeams}
          onClick={handleAddTeamClick}
          enablePurchaseLicenseLink={false}
          data-testid="PlatformAdminUI-AddTeam-MultiSelectSearch"
        />
      </Popover>
    </>
  );
};
